// Angular Core
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  BrowserModule,
  HammerGestureConfig,
  HAMMER_GESTURE_CONFIG
} from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
// Routing
import { AppComponent } from './app.component';

//Thirdparty Dependencies - table and model
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ModalModule } from 'ngx-bootstrap';

// Layout Service - Required
import { pagesToggleService } from './@hornbillfx/services/toggler.service';

// Shared Layout Components
// import { SidebarComponent } from './@hornbillfx/components/sidebar/sidebar.component';
import { QuickviewService } from './@hornbillfx/components/quickview/quickview.service';
import { pgListViewModule } from './@hornbillfx/components/list-view/list-view.module';
import { pgCardModule } from './@hornbillfx/components/card/card.module';
import { pgCardSocialModule } from './@hornbillfx/components/card-social/card-social.module';

// Basic Bootstrap Modules
import {
  BsDropdownModule,
  AccordionModule,
  AlertModule,
  ButtonsModule,
  CollapseModule,
  // ModalModule,
  ProgressbarModule,
  TabsModule,
  TooltipModule,
  TypeaheadModule
} from 'ngx-bootstrap';

// Pages Globaly required Components - Optional
import { pgTabsModule } from './@hornbillfx/components/tabs/tabs.module';
import { pgSwitchModule } from './@hornbillfx/components/switch/switch.module';
import { ProgressModule } from './@hornbillfx/components/progress/progress.module';

// Thirdparty Components / Plugins - Optional
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// Sample Blank Pages - Optional
import { BlankCorporateComponent } from './@hornbillfx/layouts/blank-corporate/blank-corporate.component';
import { BlankSimplywhiteComponent } from './@hornbillfx/layouts/blank-simplywhite/blank-simplywhite.component';
import { BlankCasualComponent } from './@hornbillfx/layouts/blank-casual/blank-casual.component';
import { SuperAdminDashboardComponent } from './super-admin-dashboard/super-admin-dashboard.component';
import { UsersLayoutComponent } from './@hornbillfx/layouts/users-layout/users-layout.component';
import { AdminLayoutComponent } from './@hornbillfx/layouts/admin-layout/admin-layout.component';
import { UserService } from './services/user.service';
import { UserModule } from './user-module/user.module';
import { GetCourseTreeObject } from './stores/usercourseTreeobject.store';

import { LoginComponent } from './login/login.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserChangePasswordComponent } from './user-change-password/user-change-password.component';
import { UserForgetPassowrdComponent } from './user-forget-passowrd/user-forget-passowrd.component';
import { UserSetPasswordComponent } from './user-set-password/user-set-password.component';
import { ClientDetailsService } from './services/client-login-details.service';
import { AdminComponent } from './feature-modules/admin/admin.component';
import { AdminModule } from './feature-modules/admin/admin.module';
import { DragulaModule } from 'ng2-dragula';
import { UserAuthService } from './services/user-auth.service';
import { IslogedInService } from './services/isloged-in.service';
import { AuthGuard } from './user-module/auth-guard';
import { SharedModule } from './@hornbillfx/components/shared.module';
import { EncriptDecriptService } from './services/encriptdecript';
import { TestCandidateComponent } from './test-candidate/test-candidate.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LoginAkkuComponent } from './login-akku/login-akku.component';
import { BcmLoginComponent } from './bcm-login/bcm-login.component';
import { ViewTestResultsComponent } from './view-test-results/view-test-results.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

// Hammer Config Overide
// https://github.com/angular/angular/issues/10541
export class AppHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    pinch: { enable: false },
    rotate: { enable: false }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    // SidebarComponent,
    // HeaderComponent,
    // HorizontalMenuComponent,
    BlankCorporateComponent,
    BlankSimplywhiteComponent,
    BlankCasualComponent,
    SuperAdminDashboardComponent,
    UsersLayoutComponent,
    AdminLayoutComponent,
    LoginComponent,
    UserProfileComponent,
    UserChangePasswordComponent,
    UserForgetPassowrdComponent,
    UserSetPasswordComponent,
    TestCandidateComponent,
    LoginAkkuComponent,
    BcmLoginComponent,
    ViewTestResultsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    SharedModule,
    ProgressModule,
    pgListViewModule,
    pgCardModule,
    pgCardSocialModule,
    // for login component defualt redirect path
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    CollapseModule.forRoot(),
    ProgressbarModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    pgTabsModule,
    PerfectScrollbarModule,
    pgSwitchModule,
    RouterModule,
    ReactiveFormsModule,
    UserModule,
    AdminModule,
    DragulaModule.forRoot(),
    NgxDatatableModule,
    ModalModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    QuickviewService,
    pagesToggleService,
    UserService,
    EncriptDecriptService,
    ClientDetailsService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: AppHammerConfig
    },
    GetCourseTreeObject,
    UserAuthService,
    AuthGuard,
    IslogedInService
  ],
  bootstrap: [AppComponent],
  entryComponents: [AdminComponent, UsersLayoutComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/app.module.ts